import React from 'react';
import CheckboxToggle from '../../design-system/checkbox-toggle.jsx';

export const CheckboxSwitcher = ({
  className,
  isSubscribed,
  isPending = false,
  onChange
}) => (
  <CheckboxToggle
    className={className}
    isPending={isPending}
    selected={isSubscribed}
    onChange={() => onChange(!isSubscribed)}
  >
    Subscribe &amp;&nbsp;save
  </CheckboxToggle>
);
